import { Analytics } from './analytics';

export function InitializeMemberSegment() {
    window.addEventListener('load', () => {
        var analytics = new Analytics();
        analytics.PushMemberSegment();
    });
}


// WEBPACK FOOTER //
// ./Static/javascript/modules/member-segment.ts